export class MarkMessageUnstarredRequest {
  private Action = 'MarkMessageUnstarred';
  public PublicToken: string;
  public MessageId: number;

  constructor({ PublicToken, MessageId }) {
    this.PublicToken = PublicToken;
    this.MessageId = MessageId;
  }
}
